import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError((error: any) => {
                    // MARK: Implement a strategy!
                    // this.modalService
                    //     .showModalError('HTTP Error', `<p>Status Code: ${error.status}<br>Message: ${error.message}`);

                    console.error(`HEI ->`, error);
                    return throwError(() => error);
                })
            );
    }
}